<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gNLJDP/tc-custom/9781250015884.jpg?1740685804301" alt="This image is the cover for the book Valley of the Shadow, Cornish Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Valley of the Shadow, Cornish Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p>A cryptic message spurs Eleanor, Megan, and Nick Gresham on a frantic search for a refugee's missing family, in <i>The Valley of the Shadow</i>, a Cornish Mystery from Carola Dunn.<br/><br/>While out on a walk, Eleanor Trewynn, her niece Megan, and her neighbor Nick spot a young, half-drowned Indian man floating in the water. Delirious and concussed, he utters a cryptic message about his family being trapped in a cave and his mother dying. The young man, unconscious and unable to help, is whisked away to a hospital while a desperate effort is mounted find the missing family in time. <br/><br/>The local police inspector presumes that they are refugees from East Africa, abandoned by the smugglers who brought them into England, so while the Cornwall countryside is being scoured for the family, Eleanor herself descends into a dangerous den of smugglers in a desperate search to find the man responsible while there is still time.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carola Dunn
      </h2>
      
      <p class="authorDescription body article"><P>CAROLA DUNN is the author of numerous books, including <I>Manna from Hades</I> and <I>A Colourful Death,</I> the two previous books featuring Eleanor Trewynnm. Born and raised in England, she lives in Eugene, Oregon.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2ecf67da